/**
 * Portuguese Features Translations
 * 特性翻译模块 - 葡萄牙语
 * 
 * SEO 关键词覆盖：
 * - aquecedor infravermelho / aquecimento radiante
 * - eficiência energética / economia de energia
 * - revestimento nano / emissividade
 */

import type { FeaturesTranslations } from '../../types';

export const ptFeatures: FeaturesTranslations = {
  tech: {
    title: 'Elemento de Aquecimento Inovador de Infravermelho Distante',
    description: 'Os aquecedores infravermelhos JH emitem raios infravermelhos distantes que aquecem diretamente pessoas e objetos — como a luz natural do sol. Esse aquecimento radiante proporciona calor rápido, uniforme e silencioso, sem ruído, vento, luz ou poeira, com consumo de energia até 80% menor do que aquecedores de convecção convencionais.',
    aluminum: 'Liga de alumínio especial tipo aletado para rápida condução de calor',
    nano: 'Revestimento NANO-cerâmico patenteado para máxima emissão de infravermelho distante',
    insulation: '86% de eficiência de emissão de raios infravermelhos distantes — líder na indústria',
    lifespan: 'Tecnologia patenteada de armazenamento de calor reflexivo (+20% economia de energia)',
  },
};
